import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Custom Hook for HMS modules
export const useOrganizations = () => {
  const { pathname } = useLocation();

  // Directly define HMS modules
  const hmsModules = [];

  const [sidebarModules, setSidebarModules] = useState(undefined);

  useEffect(() => {
    // Set the sidebar modules to the HMS modules
    setSidebarModules(hmsModules);
  }, [pathname]);

  return { sidebarModules };
};